export default __webpack_public_path__ + "static/media/itau.c9e2c1ea.svg";